import React, { useEffect } from 'react';
import useAnimationLoop from './useAnimationLoop';
import styles from './ContinuousCarousel.module.scss';
import List from './List/HomeNewsList';
import { useInView } from 'react-intersection-observer';

const ContinuousCarousel = ({ articles, readText }) => {
  const {
    containerRef,
    translateX,
    hoverPosition,
    onStop,
    onPlay,
    onMouseMoveContainer,
    onMouseMove,
    onMouseLeave,
  } = useAnimationLoop();

  const [setElementRef, inView] = useInView({
    threshold: 0.1,
  });

  useEffect(() => {
    if (inView) {
      onPlay();
    } else {
      onStop();
    }
  }, [inView]);

  return (
    <div
      ref={setElementRef}
      onMouseMove={onMouseMoveContainer}
      onMouseEnter={onStop}
      onMouseLeave={onPlay}
      className={styles.container}
    >
      <div
        ref={containerRef}
        style={{
          display: 'flex',
          whiteSpace: 'nowrap',
          transform: `translateX(${translateX}px)`,
          willChange: 'transform',
          transition: 'transform 0s',
        }}
      >
        <List
          articles={articles}
          hoverPosition={hoverPosition}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
          readText={readText}
        />
        {/* Duplicate list (don't remove) */}
        <List
          articles={articles}
          hoverPosition={hoverPosition}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
          readText={readText}
        />
      </div>
    </div>
  );
};

export default ContinuousCarousel;
